function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { reducer as beesReducer } from '@applyboard/redux-bees';
import deepMerge from "../../util/deep_merge";
import { entityReducer } from "./entities_reducer";
var fetchRelatedData = function fetchRelatedData(state, payload, parent) {
  if (!payload || !payload.body || !payload.body.data || !Array.isArray(payload.body.data)) {
    console.warn('invalid payload format:', payload);
    return state;
  }
  var entityList = _objectSpread({}, state.entities[parent.type]);
  var originalParentEntity = null;
  var parentEntity = null;
  try {
    originalParentEntity = entityList[parent.id];
    parentEntity = _objectSpread({}, originalParentEntity);
    if (!originalParentEntity) throw new Error("cannot find ".concat(parent.type, ":").concat(parent.id, " in state"));
    entityList[parent.id] = parentEntity;
  } catch (err) {
    console.error('error finding parent entity');
    console.error(err);
    return state;
  }
  parentEntity.relationships = _objectSpread({}, parentEntity.relationships);
  payload.body.data.forEach(function (entry) {
    if (parentEntity.relationships[entry.type] === originalParentEntity.relationships[entry.type]) {
      parentEntity.relationships[entry.type] = _objectSpread({}, parentEntity.relationships[entry.type]);
    }
    var currentRelationship = parentEntity.relationships[entry.type];
    if (!currentRelationship.data) {
      currentRelationship.data = [];
    }
    var exists = currentRelationship.data.find(function (e) {
      return e.type === entry.type && e.id === entry.id;
    });
    if (!exists) {
      currentRelationship.data = currentRelationship.data.concat({
        type: entry.type,
        id: entry.id
      });
    }
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    entities: _objectSpread(_objectSpread({}, state.entities), {}, _defineProperty({}, parent.type, entityList))
  });
};

/**
 * Updates the state after deleting some requirement attachments.  The
 * attachment entities themselves need to be removed along with the relationship
 * data structure that associates requirements with requirement attachments
 *
 * It also updates the status of the requirement with the new status, which may
 * have changed due to deleting attachments
 */
var handleDeleteRequirementAttachments = function handleDeleteRequirementAttachments(state, action) {
  var newState = state;
  if (!state.entities.attachments || !action.requirementId || !action.requirementStatus || !action.requirementType) {
    return newState;
  }
  newState = removeRequirementAttachmentEntities(newState, action);
  if (action.requirementType === 'document') {
    newState = updateDocumentRequirementsAfterAttachmentDeletions(newState, action);
  } else {
    newState = updateReceiptRequirementsAfterAttachmentDeletions(newState, action);
  }
  return newState;
};

/**
 * Updates a document requirement with necessary changes after deleting some of
 * its attachments
 */
function updateDocumentRequirementsAfterAttachmentDeletions(state, action) {
  var _state$entities, _oldDocumentRequireme, _oldDocumentRequireme2;
  var requirementAttachmentIds = action.requirementAttachmentIds.map(function (id) {
    return id.toString();
  });
  var oldDocumentRequirements = (_state$entities = state.entities) === null || _state$entities === void 0 ? void 0 : _state$entities.application_document_requirements;
  var oldDocumentRequirement = oldDocumentRequirements === null || oldDocumentRequirements === void 0 ? void 0 : oldDocumentRequirements[action.requirementId];
  var oldAttachmentRelationships = (oldDocumentRequirement === null || oldDocumentRequirement === void 0 ? void 0 : (_oldDocumentRequireme = oldDocumentRequirement.relationships) === null || _oldDocumentRequireme === void 0 ? void 0 : (_oldDocumentRequireme2 = _oldDocumentRequireme.attachments) === null || _oldDocumentRequireme2 === void 0 ? void 0 : _oldDocumentRequireme2.data) || [];
  var newDocumentRequirements = oldDocumentRequirement ? deepMerge(oldDocumentRequirements, _defineProperty({}, action.requirementId, {
    attributes: {
      // There's a new status after deleting attachments.  This can happen,
      // for example, if you delete the last attachment - the requirement
      // changes status to missing
      status: action.requirementStatus
    },
    relationships: {
      attachments: {
        // Need to remove any stale relationships to deleted requirement attachments
        data: oldAttachmentRelationships.filter(function (attachment) {
          return !requirementAttachmentIds.includes(attachment.id.toString());
        })
      }
    }
  })) : oldDocumentRequirements;
  return _objectSpread(_objectSpread({}, state), {}, {
    entities: _objectSpread(_objectSpread({}, state.entities), {}, {
      application_document_requirements: newDocumentRequirements
    })
  });
}

/**
 * Updates a receipt requirement with necessary changes after deleting some of
 * its attachments
 */
function updateReceiptRequirementsAfterAttachmentDeletions(state, action) {
  var _state$entities2, _oldReceiptRequiremen, _oldReceiptRequiremen2;
  var requirementAttachmentIds = action.requirementAttachmentIds.map(function (id) {
    return id.toString();
  });
  var oldReceiptRequirements = (_state$entities2 = state.entities) === null || _state$entities2 === void 0 ? void 0 : _state$entities2.application_receipt_requirements;
  var oldReceiptRequirement = oldReceiptRequirements === null || oldReceiptRequirements === void 0 ? void 0 : oldReceiptRequirements[action.requirementId];
  var oldAttachmentRelationships = (oldReceiptRequirement === null || oldReceiptRequirement === void 0 ? void 0 : (_oldReceiptRequiremen = oldReceiptRequirement.relationships) === null || _oldReceiptRequiremen === void 0 ? void 0 : (_oldReceiptRequiremen2 = _oldReceiptRequiremen.attachments) === null || _oldReceiptRequiremen2 === void 0 ? void 0 : _oldReceiptRequiremen2.data) || [];
  var newReceiptRequirements = oldReceiptRequirement ? deepMerge(oldReceiptRequirements, _defineProperty({}, action.requirementId, {
    attributes: {
      // There's a new status after deleting attachments.  This can happen,
      // for example, if you delete the last attachment - the requirement
      // changes status to missing
      status: action.requirementStatus
    },
    relationships: {
      attachments: {
        // Need to remove any stale relationships to deleted requirement attachments
        data: oldAttachmentRelationships.filter(function (attachment) {
          return !requirementAttachmentIds.includes(attachment.id.toString());
        })
      }
    }
  })) : oldReceiptRequirements;
  return _objectSpread(_objectSpread({}, state), {}, {
    entities: _objectSpread(_objectSpread({}, state.entities), {}, {
      application_receipt_requirements: newReceiptRequirements
    })
  });
}

/**
 * Removes some requirement attachments from the entities section
 */
function removeRequirementAttachmentEntities(state, action) {
  var newRequirementAttachmentIds = _objectSpread({}, state.entities.attachments);
  var _iterator = _createForOfIteratorHelper(action.requirementAttachmentIds),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var requirementAttachmentId = _step.value;
      delete newRequirementAttachmentIds[requirementAttachmentId];
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    entities: _objectSpread(_objectSpread({}, state.entities), {}, {
      attachments: newRequirementAttachmentIds
    })
  });
}
var handlePaymentRequirementNewStatus = function handlePaymentRequirementNewStatus(state, action) {
  var previousRequirement = state.entities.application_payment_requirements[action.requirementId];
  if (!previousRequirement) {
    return state;
  }
  var nextRequirement = _objectSpread(_objectSpread({}, previousRequirement), {}, {
    attributes: _objectSpread(_objectSpread({}, previousRequirement.attributes), {}, {
      status: action.status,
      order_id: action.orderId || null
    })
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    entities: _objectSpread(_objectSpread({}, state.entities), {}, {
      application_payment_requirements: _objectSpread(_objectSpread({}, state.entities.application_payment_requirements), {}, _defineProperty({}, action.requirementId, nextRequirement))
    })
  });
};
var addSchoolsToAgent = function addSchoolsToAgent(state, agency_id, schools) {
  var previousAgent = state.entities.agencies[agency_id];
  var nextAgent = _objectSpread(_objectSpread({}, previousAgent), {}, {
    relationships: _objectSpread(_objectSpread({}, previousAgent.relationships), {}, {
      schools: {
        data: previousAgent.relationships.schools.data.concat(schools)
      }
    })
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    entities: _objectSpread(_objectSpread({}, state.entities), {}, {
      agencies: _objectSpread(_objectSpread({}, state.entities.agencies), {}, _defineProperty({}, agency_id, nextAgent))
    })
  });
};
var removeSchoolsFromAgent = function removeSchoolsFromAgent(state, agency_id, schools) {
  var previousAgent = state.entities.agencies[agency_id];
  var idsToRemove = schools.map(function (e) {
    return parseInt(e.id, 10);
  });
  var nextAgent = _objectSpread(_objectSpread({}, previousAgent), {}, {
    relationships: _objectSpread(_objectSpread({}, previousAgent.relationships), {}, {
      schools: {
        data: previousAgent.relationships.schools.data.filter(function (data) {
          return idsToRemove.indexOf(parseInt(data.id, 10)) < 0;
        })
      }
    })
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    entities: _objectSpread(_objectSpread({}, state.entities), {}, {
      agencies: _objectSpread(_objectSpread({}, state.entities.agencies), {}, _defineProperty({}, agency_id, nextAgent))
    })
  });
};
var modifyPutResponse = function modifyPutResponse(state, action, actionName) {
  var agency_id = action.meta.params[0].id;
  var requestAction = {
    type: "api/".concat(actionName, "/request"),
    meta: {
      api: true,
      name: actionName,
      params: [{
        id: agency_id
      }],
      type: 'request'
    }
  };
  var responseAction = {
    type: "api/".concat(actionName, "/response"),
    meta: {
      api: true,
      name: actionName,
      params: [{
        id: agency_id
      }],
      type: 'response'
    },
    payload: action.payload
  };
  var nextState = beesReducer(state, requestAction);
  nextState = beesReducer(state, responseAction);
  return nextState;
};

// TODO: This should have its own file and some auxiliary functions

var updateEntityOnState = function updateEntityOnState(state, entity) {
  var type = entity.type,
    id = entity.id;
  return deepMerge(state, {
    entities: _defineProperty({}, type, _defineProperty({}, id, entity))
  });
};
var fixRelationships = function fixRelationships(prevState, nextState, action) {
  // TODO: Add support for arrays
  if (!action || !action.payload || !action.payload.body) return nextState;
  var payloadBody = action.payload.body;
  var originalPayloadData = payloadBody.data;
  var previousEntities = prevState.entities;
  var nextEntities = nextState.entities;
  if (!action.meta || action.meta.type !== 'response' || _typeof(originalPayloadData) !== 'object' || Array.isArray(originalPayloadData)) {
    return nextState;
  }
  var getNextData = function getNextData(payloadData) {
    var entity_type = payloadData.type;
    var entity_id = payloadData.id;
    var previousDataTypeMap = previousEntities[entity_type];
    if (!previousDataTypeMap) return payloadData;
    var previousData = previousDataTypeMap[entity_id];
    if (!previousData) return payloadData;
    if (!previousData.relationships) return payloadData;
    if (Object.keys(previousData.relationships).length <= 0) return payloadData;

    // Make a copy of the relevant data
    var nextData = _objectSpread(_objectSpread({}, nextEntities[entity_type][entity_id]), {}, {
      relationships: nextEntities[entity_type][entity_id].relationships
    });
    Object.keys(nextData.relationships).forEach(function (relationshipKey) {
      nextData.relationships[relationshipKey] = _objectSpread({}, nextData.relationships[relationshipKey]);
    });
    Object.keys(previousData.relationships).forEach(function (relationshipKey) {
      var relationshipData = nextData.relationships[relationshipKey];
      var previousRelationships = previousData.relationships[relationshipKey];
      if (relationshipData && relationshipData.data || !previousRelationships.data) return;
      var newRelationship = _objectSpread(_objectSpread({}, relationshipData), {}, {
        data: previousRelationships.data
      });
      if (previousRelationships.meta) newRelationship.meta = previousRelationships.meta;
      nextData.relationships[relationshipKey] = newRelationship;
    });
    return nextData;
  };
  var nextData = getNextData(originalPayloadData);

  // Update the state
  var returnState = updateEntityOnState(nextState, nextData);
  if (payloadBody.included && payloadBody.included.length > 0) {
    payloadBody.included.forEach(function (entity) {
      returnState = updateEntityOnState(returnState, getNextData(entity));
    });
  }
  return returnState;
};
var ignoreActions = ['api/getRequirementCategories/response'];

// List of all entities affected by a given action
var generateUpdateListFromAction = function generateUpdateListFromAction(action) {
  var list = [];
  var data = action.payload.body.data;
  if (Array.isArray(data)) {
    data.forEach(function (entry) {
      list.push(entry);
    });
  } else {
    list.push(data);
  }
  var included = action.payload.body.included;
  if (Array.isArray(included)) {
    included.forEach(function (entry) {
      list.push(entry);
    });
  }
  return list;
};

// Updates the state with the new entry, respecting existing relationships
// The originalstate parameter is optional and should be used if the relationships
// might possibly be already overwritten by someone (redux-bees).
var updateStateWithEntry = function updateStateWithEntry(state, entry, _originalState) {
  var id = entry.id,
    type = entry.type;
  var originalState = _originalState || state;
  var nextState = _objectSpread({}, state);
  nextState.entities = nextState.entities ? _objectSpread({}, nextState.entities) : {};
  var entityTypeCollection = nextState.entities[type] ? _objectSpread({}, nextState.entities[type]) : {};
  nextState.entities[type] = entityTypeCollection;
  var originalRelationships = null;
  try {
    originalRelationships = originalState.entities[type][id].relationships;
  } catch (ex) {
    /* intentionally left blank */
  }
  entityTypeCollection[id] = entry;
  if (!originalRelationships) {
    return nextState;
  }
  entityTypeCollection[id].relationships = _objectSpread({}, entityTypeCollection[id].relationships);
  var currentRelationships = entityTypeCollection[id].relationships;
  Object.keys(originalRelationships).filter(function (key) {
    return !!originalRelationships[key].data;
  }).forEach(function (relationshipKey) {
    if (!currentRelationships[relationshipKey] || !currentRelationships[relationshipKey].data) {
      currentRelationships[relationshipKey] = originalRelationships[relationshipKey];
    }
  });
  return nextState;
};
var updateStateWithList = function updateStateWithList(state, entries, originalState) {
  return entries.reduce(function (s, e) {
    return updateStateWithEntry(s, e, originalState);
  }, state);
};
var reducer = function reducer(state, action) {
  var _nextState$entities$a, _nextState$entities$a2, _nextState$entities$a3, _nextState$entities$a4, _nextState$entities$a5, _nextState$entities$a6;
  var nextState = state;
  if (ignoreActions.indexOf(action.type) < 0) {
    nextState = beesReducer(nextState, action);
    try {
      var type = action.payload.body.data.type;
      if (type) {
        if (Array.isArray(nextState.entities[type])) {
          var oldEntities = nextState.entities[type];
          var newEntities = {};
          oldEntities.forEach(function (e, idx) {
            if (e) {
              newEntities[idx] = e;
            }
          });

          // this object is already a new one, so, it's ok to assign it like this.
          nextState.entities[type] = newEntities;
        }
      }
    } catch (e) {
      /* intentionally left blank */
    }
  } else {
    // Update only the request information
    var entityName = action.meta.name;
    var requestKey = JSON.stringify(action.meta.params);
    var response = null;
    var payload_data = action.payload.body.data;
    if (Array.isArray(payload_data)) {
      response = payload_data.map(function (_ref) {
        var id = _ref.id,
          type = _ref.type;
        return {
          id: id,
          type: type
        };
      });
    } else if (_typeof(payload_data) === 'object') {
      response = {
        id: payload_data.id,
        type: payload_data.type
      };
    }
    nextState = deepMerge(nextState, {
      requests: _defineProperty({}, entityName, _defineProperty({}, requestKey, {
        isLoading: false,
        response: response,
        meta: action.meta,
        headers: action.payload.headers,
        status: action.payload.status
      }))
    });
  }

  // Handle deletion
  var valid_statuses = [200, 204];
  if (action && action.payload && valid_statuses.indexOf(action.payload.status) >= 0 && action.meta && action.meta.params && Array.isArray(action.meta.params)) {
    action.meta.params.forEach(function (data) {
      if (!data) return;
      if (data.parent && data.parent.id && data.parent.type) {
        nextState = fetchRelatedData(nextState, action.payload, data.parent);
        return;
      }
      if (!data.method) return;
      // @ts-ignore -- typescript is telling method is always a boolean. typescript is wrong.
      if (!data.method === 'destroy') return;
      if (data.type && data.id) {
        // delete an specific id/type pair
        var _type2 = data.type,
          id = data.id;

        // Copies the entity type that we want
        nextState = _objectSpread(_objectSpread({}, nextState), {}, {
          entities: _objectSpread(_objectSpread({}, nextState.entities), {}, _defineProperty({}, _type2, _objectSpread({}, nextState.entities[_type2])))
        });
        if (!nextState.entities[_type2]) {
          console.warn("not found for deletion: api.entities.".concat(_type2));
        } else if (!nextState.entities[_type2][id]) {
          console.warn("not found for deletion: api.entities.".concat(_type2, ".").concat(id));
        }
        delete nextState.entities[_type2][id];
      } else if (data.type && !data.id) {
        console.warn('delete entire type is not yet implemented.');
      } else {
        console.warn("meta says destroy but we're missing the type/id");
      }
    });
  }
  try {
    // Handle makes sure that updates does not disrupt existing fetched data
    nextState = fixRelationships(state, nextState, action);
  } catch (err) {
    console.error('cannot fix relationships:', err);
  }

  // Handle auxiliary calls
  var actionName;
  nextState = entityReducer(nextState, action);

  // eslint-disable-next-line default-case -- we want no action to be taken if type does not match.
  switch (action.type) {
    // I dislike this but I don't see a better way to do this with redux-bees.
    // This file in general violates the single responsibility principle and it
    // mixes different levels of abstraction. If we move requirement attachments to
    // the data folder, this can be removed in favour of setQueryData
    case 'DELETE_REQUIREMENT_ATTACHMENTS':
      nextState = handleDeleteRequirementAttachments(nextState, action);
      break;
    // I dislike this but I don't see a better way to do this with redux-bees.
    // This file in general violates the single responsibility principle and it
    // mixes different levels of abstraction. If we move payment requirements to
    // the data folder, this can be removed in favour of setQueryData
    case 'PAYMENT_REQUIREMENT_NEW_STATUS':
      nextState = handlePaymentRequirementNewStatus(nextState, action);
      break;
    case 'ADD_SCHOOLS_TO_AGENT':
      nextState = addSchoolsToAgent(nextState, action.agency_id, action.value);
      break;
    case 'REMOVE_SCHOOLS_FROM_AGENT':
      nextState = removeSchoolsFromAgent(nextState, action.agency_id, action.value);
      break;
    case 'api/putAgencyManager/response':
      actionName = 'getAgency';
      nextState = deepMerge(modifyPutResponse(nextState, action, actionName), {
        entities: {
          agencies: _defineProperty({}, action.meta.params[0].id, {
            relationships: {
              agent_manager: _objectSpread({}, action.meta.params[1])
            }
          })
        }
      });
      break;
    case 'setAgencyUpload':
      nextState = deepMerge(nextState, {
        entities: _defineProperty({
          agencies: _defineProperty({}, action.agency_id, {
            relationships: _defineProperty({}, action.relationship_name, {
              data: {
                type: action.attachment_type,
                id: action.attachment_id
              },
              meta: null
            })
          })
        }, action.attachment_type, _defineProperty({}, action.attachment_id, action.data))
      });
      break;
    case 'api/getAgency/response':
      actionName = 'getAgency';
      nextState = deepMerge(modifyPutResponse(nextState, action, actionName), {
        entities: {
          agencies: _defineProperty({}, action.meta.params[0].id, {
            relationships: {
              agent_manager: _objectSpread({}, action.meta.params[1])
            }
          })
        }
      });
      break;
    case 'api/deleteAgencyManager/response':
      nextState = deepMerge(nextState, {
        entities: {
          agencies: _defineProperty({}, action.meta.params[0].id, {
            relationships: {
              agent_manager: {
                data: null
              }
            }
          })
        }
      });
      break;
    case 'api/putStudentsAgency/response':
      nextState = deepMerge(nextState, {
        entities: {
          students: _defineProperty({}, action.meta.params[0].id, {
            relationships: {
              agency: {
                data: action.meta.params[1].data
              }
            }
          })
        }
      });
      break;
    case 'api/destroyStudentsAgency/response':
      nextState = deepMerge(nextState, {
        entities: {
          students: _defineProperty({}, action.meta.params[0].id, {
            relationships: {
              agency: {
                data: null
              }
            }
          })
        }
      });
      break;
    case 'setUserProfilePicUpload':
      nextState = deepMerge(nextState, {
        entities: _defineProperty({
          users: _defineProperty({}, action.user_id, {
            relationships: _defineProperty({}, action.relationship_name, {
              data: {
                type: action.attachment_type,
                id: action.attachment_id
              },
              meta: null
            })
          })
        }, action.attachment_type, _defineProperty({}, action.attachment_id, action.data))
      });
      break;
    case 'api/destroyStudentsSalesRep/response':
      nextState = deepMerge(nextState, {
        entities: {
          students: _defineProperty({}, action.meta.params[0].id, {
            relationships: {
              sales_representative: {
                data: null
              }
            }
          })
        }
      });
      break;
    case 'api/destroyStudentImmigrationConsultant/response':
      nextState = deepMerge(nextState, {
        entities: {
          students: _defineProperty({}, action.meta.params[0].id, {
            relationships: {
              immigration_consultant: {
                data: null
              }
            }
          })
        }
      });
      break;
    case 'api/getRequirementCategories/response':
      // The relationships from requirement_categories are being overwritten.
      // prevent that here.
      nextState = deepMerge(nextState, {
        entities: {
          requirement_categories: _objectSpread({}, action.payload.body.data.reduce(
          // TODO: Remove meta.included if it's false and we already have data.
          function (response, data) {
            return _objectSpread(_objectSpread({}, response), {}, _defineProperty({}, data.id, data));
          }, {}))
        }
      });
      break;

    // Handle requirement modal json api calls
    case 'api/deleteRequirementAttachment/response':
      nextState = deepMerge(nextState, {
        entities: _defineProperty({}, action.meta.params[0].type, _defineProperty({}, action.meta.params[0].template_id, {
          relationships: {
            additional_attachments: {
              data: nextState.entities[action.meta.params[0].type][action.meta.params[0].template_id].relationships.additional_attachments.data.filter(function (el) {
                return el.id != action.meta.params[0].id;
              })
            }
          }
        }))
      });
      break;
    case 'api/deleteRequirementExternalLink/response':
      nextState = deepMerge(nextState, {
        entities: _defineProperty({}, action.meta.params[0].type, _defineProperty({}, action.meta.params[0].template_id, {
          relationships: {
            external_links: {
              data: nextState.entities[action.meta.params[0].type][action.meta.params[0].template_id].relationships.external_links.data.filter(function (el) {
                return el.id != action.meta.params[0].id;
              })
            }
          }
        }))
      });
      break;
    case 'api/putRolePermissions/response':
      nextState = deepMerge(nextState, {
        entities: {
          roles: _defineProperty({}, action.meta.params[0].id, {
            relationships: {
              permissions: {
                data: action.payload.body.data.map(function (d) {
                  return {
                    id: d.id,
                    type: d.type
                  };
                })
              }
            }
          })
        }
      });
      break;
    case 'UPDATE_REQUIREMENT_STATUS':
      if (!action.data || !action.data.id || !action.data.attributes) {
        console.warn('invalid action passed to UPDATE_REQUIREMENT_STATUS', action);
        break;
      }
      nextState = deepMerge(nextState, {
        entities: _defineProperty({}, action.data.type, _defineProperty({}, action.data.id, {
          attributes: {
            status: action.data.attributes.status
          }
        }))
      });
      break;
    case 'ADD_RECEIPT_ATTACHMENT_TO_REQUIREMENT':
      // required stuff:
      // data: the whole attachment data. must be an object that has at least
      // id, type and attributes.
      // requirement_id: the owner of the attachment
      if (!action.data || !action.data.id || !action.data.type || !action.data.attributes) {
        console.warn('invalid action passed to ADD_RECEIPT_ATTACHMENT_TO_REQUIREMENT', action);
        break;
      }
      nextState = deepMerge(nextState, {
        entities: {
          attachments: _defineProperty({
            type: 'attachments'
          }, action.data.id, action.data),
          application_receipt_requirements: _defineProperty({}, action.requirement_id, {
            attributes: {
              status: action.data.attributes.requirement_status
            },
            relationships: {
              attachments: {
                data: [].concat(_toConsumableArray((_nextState$entities$a = (_nextState$entities$a2 = nextState.entities.application_receipt_requirements[action.requirement_id].relationships) === null || _nextState$entities$a2 === void 0 ? void 0 : (_nextState$entities$a3 = _nextState$entities$a2.attachments) === null || _nextState$entities$a3 === void 0 ? void 0 : _nextState$entities$a3.data) !== null && _nextState$entities$a !== void 0 ? _nextState$entities$a : []), [{
                  id: action.data.id,
                  type: 'attachments'
                }])
              }
            }
          })
        }
      });
      break;
    case 'ADD_ATTACHMENT_TO_REQUIREMENT':
      // case 'ADD_RECEIPT_ATTACHMENT_TO_REQUIREMENT': // duplicated.
      // required stuff:
      // data: the whole attachment data. must be an object that has at least
      // id, type and attributes.
      // requirement_id: the owner of the attachment
      if (!action.data || !action.data.id || !action.data.type || !action.data.attributes) {
        console.warn("invalid action passed to ".concat(action.type), action);
        break;
      }
      nextState = deepMerge(nextState, {
        entities: {
          attachments: _defineProperty({}, action.data.id, _objectSpread({
            type: 'attachments'
          }, action.data)),
          application_document_requirements: _defineProperty({}, action.requirement_id, {
            attributes: {
              status: action.data.attributes.requirement_status
            },
            relationships: {
              attachments: {
                data: [].concat(_toConsumableArray((_nextState$entities$a4 = (_nextState$entities$a5 = nextState.entities.application_document_requirements[action.requirement_id].relationships) === null || _nextState$entities$a5 === void 0 ? void 0 : (_nextState$entities$a6 = _nextState$entities$a5.attachments) === null || _nextState$entities$a6 === void 0 ? void 0 : _nextState$entities$a6.data) !== null && _nextState$entities$a4 !== void 0 ? _nextState$entities$a4 : []), [{
                  id: action.data.id,
                  type: 'attachments'
                }])
              }
            }
          })
        }
      });
      break;
    case 'REQUIREMENT_ATTACHMENT_DELETED':
      if (!action.data || !action.data.id || !action.data.attributes) {
        console.warn('invalid action passed to REQUIREMENT_ATTACHMENT_DELETED', action);
        break;
      }
      nextState = deepMerge(nextState, {
        entities: {
          application_document_requirements: _defineProperty({}, action.data.id, {
            attributes: {
              status: action.data.attributes.status
            }
          })
        }
      });
      break;
    case 'UPDATE_QUESTION_ANSWERED':
      // required stuff:
      // data: requirement id, requirement type and requirement status. must be an object that has at least
      // id, type and status.
      if (!action.data || !action.data.id || !action.data.type || !action.data.attributes) {
        console.warn('invalid action passed to UPDATE_QUESTION_ANSWERED', action);
        break;
      }
      nextState = deepMerge(nextState, {
        entities: {
          application_questions_requirements: _defineProperty({}, action.requirement_id, {
            attributes: {
              status: action.data.attributes.requirement_status
            }
          }),
          application_questions: _defineProperty({}, action.data.id, {
            attributes: {
              status: action.data.attributes.status,
              status_note: action.data.attributes.status_note,
              answers: action.data.attributes.answers
            }
          })
        }
      });
      break;
    case 'UPDATE_ANSWER_STATUS':
      if (!action.data || !action.data.id || !action.data.type || !action.data.attributes) {
        console.warn('invalid action passed to UPDATE_ANSWER_STATUS', action);
        break;
      }
      nextState = deepMerge(nextState, {
        entities: {
          application_questions: _defineProperty({}, action.data.id, {
            attributes: {
              status: action.data.attributes.status,
              status_note: action.data.attributes.status_note,
              answers: action.data.attributes.answers
            }
          })
        }
      });
      break;
    case 'UPDATE_ATTACHMENT_STATUS':
      if (!action.data || !action.data.id || !action.data.type || !action.data.attributes) {
        console.warn('invalid action passed to UPDATE_ANSWER_STATUS', action);
        break;
      }
      nextState = deepMerge(nextState, {
        entities: {
          attachments: _defineProperty({}, action.data.id, {
            attributes: {
              status: action.data.attributes.status,
              status_note: action.data.attributes.status_note
            }
          })
        }
      });
      break;
    case 'REMOVE_MASTER_AGENCY':
      nextState = _objectSpread(_objectSpread({}, nextState), {}, {
        entities: _objectSpread(_objectSpread({}, nextState.entities), {}, {
          agencies: _objectSpread(_objectSpread({}, nextState.entities.agencies), {}, _defineProperty({}, action.value, _objectSpread(_objectSpread({}, nextState.entities.agencies[action.value]), {}, {
            relationships: _objectSpread(_objectSpread({}, nextState.entities.agencies[action.value].relationships), {}, {
              master_agency: {
                data: null
              }
            })
          })))
        })
      });
      break;

    // These cases updates the new incoming entities without removing the existing relationships.
    case 'api/getMultipleApplications/response':
      nextState = updateStateWithList(nextState, generateUpdateListFromAction(action), state);
      break;
  }
  return nextState;
};
export default reducer;